import { createSlice } from '@reduxjs/toolkit'

import { ErrorAction, InitialState } from '../types'

const initialState: InitialState = {
  errors: [],
}

const XlsxValidationSlice = createSlice({
  name: 'xlsxValidation',
  initialState,
  reducers: {
    setXlsxValidationErrors(state, action: ErrorAction) {
      state.errors = action.payload
    },
    clearXlsxValidationErrors(state) {
      state.errors = []
    },
  },
})

const XlsxValidationSliceReducer = XlsxValidationSlice.reducer

export const { setXlsxValidationErrors, clearXlsxValidationErrors } = XlsxValidationSlice.actions
export default XlsxValidationSliceReducer
